import { ValorCartaCreditoFinanceiro } from "./valor-carta-credito.model";

export class AcumuladoVO {

  valorExcedenteAcumuladoCalculado: ValorCartaCreditoFinanceiro;
  valorExcedenteAcumuladoAnterior: ValorCartaCreditoFinanceiro;
  valorExcedenteUtilizado: ValorCartaCreditoFinanceiro;
  valorExcedenteUtilizadoTecnac: ValorCartaCreditoFinanceiro;
  valorRemanescenteAcumuladoAnterior: ValorCartaCreditoFinanceiro;
  valorRemanescenteAcumuladoCalculado: ValorCartaCreditoFinanceiro;
  valorRemanescenteUtilizado: ValorCartaCreditoFinanceiro;
  valorRemanescenteUtilizadoTecnac: ValorCartaCreditoFinanceiro

}
